let pendingMcpAuthRequest = ''

export const storeMcpAuthRequest = (authRequest: string) => {
  pendingMcpAuthRequest = authRequest
}

export const getMcpAuthRequest = () => pendingMcpAuthRequest

export const clearMcpAuthRequest = () => {
  pendingMcpAuthRequest = ''
}
